<template>
    <div class="change">
        <div class="title">修改密码</div>
        <div class="account">
            <div class="acte">手机号：</div>
            <div class="key">{{userName}}</div>
        </div>
        <div class="account" style="margin-top: 40px;">
            <div class="acte">验证码：</div>
            <div class="input">
                <el-input v-model="code"></el-input>
                <button class="btn" @click="handlCheckGetCode" :disabled="codeButt.status">{{codeButt.text}}</button>
            </div>
        </div>
        <div class="account">
            <div class="acte">新密码：</div>
            <div class="input">
                <!-- <el-input v-model="passWord"></el-input> -->


                <el-form ref="login" :rules="rules" :model="param">
                    <el-form-item prop="passWord">
                        <el-input placeholder="请输入新密码" prefix-icon="el-icon-lock" v-model="param.passWord" clearable
                                  show-password
                                  auto-complete="new-password"
                                  :readonly="passReadonly"
                                  @focus="handlInputClick"
                        >
                        </el-input>
                    </el-form-item>
                </el-form>

            </div>
        </div>
        <div class="account">
            <div class="acte">确定新密码：</div>
            <div class="input">
                <el-input v-model="param.aginPassWord"
                          show-password
                          auto-complete="new-password"
                          :readonly="passReadonly"
                          @focus="handlInputClick"
                ></el-input>
            </div>
        </div>
        <div class="submin" @click="handlCheckSubmin">提交</div>

        <el-dialog
                title="身份验证"
                :visible.sync="userDialogVisible"
                width="30%"
                center id="userDialog"
                @close="handlDialogClose">
            <div class="dialog_num">
                <div class="idCard">
                    <el-input ref="idCard1" class="code-input" maxlength="1" v-model="idCard.one" @input="changeHandler"></el-input>
                </div>
                <div class="idCard">
                    <el-input ref="idCard2" class="code-input" maxlength="1" v-model="idCard.two" @input="changeHandler"></el-input>
                </div>
                <div class="idCard">
                    <el-input ref="idCard3" class="code-input" maxlength="1" v-model="idCard.three" @input="changeHandler"></el-input>
                </div>
                <div class="idCard">
                    <el-input ref ="idCard4"class="code-input" maxlength="1" v-model="idCard.four" @input="changeHandler"></el-input>
                </div>
            </div>
            <div class="dialog_text">
                请输入身份证后四位
            </div>
            <div class="dialog_btn" @click="handlCheckCard">确认</div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                passReadonly: true,
                code: '',
                param: {
                    passWord: '',
                    aginPassWord: '',
                },
                isCheck: 0,
                userName: this.$global.webData.phone,
                userDialogVisible: true,
                idCard: {
                    one: '',
                    two: '',
                    three: '',
                    four: ''
                },
                codeButt: {
                    text: '获取验证码',
                    status: false,
                    value: ''
                },
                rules: {
                    passWord: [{
                        required: true,
                        message: '请输入密码',
                        trigger: 'blur'
                    },
                        {
                            min: 6,
                            max: 15,
                            message: '密码长度应大于等于6个字符小于16个字符!',
                            trigger: "blur"
                        },
                        {
                            trigger: 'blur',
                            validator: (rule, value, callback) => {
                                var passwordreg = /(?![A-Z]*$)(?![a-z]*$)(?![0-9]*$)(?![^a-zA-Z0-9]*$)/
                                console.log(passwordreg.test(value))
                                if (!passwordreg.test(value)) {
                                    callback(new Error('密码必须由大写字母、小写字母、数字、特殊符号中的2种及以上类型组成!'))
                                } else {
                                    callback()
                                }
                            }
                        },
                    ],
                },
            }
        },
        mounted() {
            this.$emit('test', '四川相君科技有限公司');
        },
        created() {
            this.$nextTick(() => {
                this.$refs.idCard1.$el.querySelector('input').focus()
            })
        },
        methods: {
            changeHandler(){
                let ref = undefined
                if(this.idCard.one.length===0){
                    ref = this.$refs.idCard1
                }else if(this.idCard.two.length===0){
                    ref = this.$refs.idCard2
                }else if(this.idCard.three.length===0){
                    ref = this.$refs.idCard3
                }else if(this.idCard.four.length===0){
                    ref = this.$refs.idCard4
                }
                if(ref!==undefined){
                    this.$nextTick(() => {
                        ref.$el.querySelector('input').focus()
                    })
                }else{
                    this.$refs.idCard1.$el.querySelector('input').blur()
                    this.$refs.idCard2.$el.querySelector('input').blur()
                    this.$refs.idCard3.$el.querySelector('input').blur()
                    this.$refs.idCard4.$el.querySelector('input').blur()
                }
            },
            handlInputClick(){
                this.passReadonly = false
            },
            handlDialogClose() {
                if (this.isCheck == 0) {
                    this.$router.push('vipCenter');
                }
            },
            handlCheckGetCode() {
                this.codeButt.status = true;
                let countdown = 60;
                let _this = this;
                let param = new URLSearchParams();
                param.append('phone', this.$global.webData.phone);
                param.append('type', 3);
                _this.api.sendCodeToPhone(param).then(res => {
                    console.log(res)
                    _this.$message.success("发送成功");
                    _this.codeButt.text = countdown + '秒';
                    _this.codeButt.status = true;
                    let timer = setInterval(() => {
                        if (countdown > 0) {
                            _this.codeButt.text = countdown - 1 + '秒';
                            countdown--;
                        } else {
                            clearInterval(timer);
                            _this.codeButt.text = '获取验证码';
                            _this.codeButt.status = false;
                        }
                    }, 1000);
                }).catch(e => {
                    _this.codeButt.status = false;
                })
                // let param = new FormData();
                // param.append('email', _this.$global.webData.email);
                // param.append('type', '2');
                // _this.api.sendCodeToEmail(param).then(res => {
                //     console.log(res);
                //     _this.$message.success('发送成功');
                //     _this.codeButt.text = countdown + '秒';
                //     _this.codeButt.status = true;
                //     let timer = setInterval(() => {
                //         if (countdown > 0) {
                //             _this.codeButt.text = countdown - 1 + '秒';
                //             countdown--;
                //         } else {
                //             clearInterval(timer);
                //             _this.codeButt.text = '获取验证码';
                //             _this.codeButt.status = false;
                //         }
                //     }, 1000);
                // }).catch(e => {
                //     _this.codeButt.status = false;
                // })
            },
            handlCheckCard() {
                let _this = this;
                if (this.idCard.one && this.idCard.two && this.idCard.three && this.idCard.four) {
                    let idCode = this.idCard.one + this.idCard.two + this.idCard.three + this.idCard.four;
                    console.log(idCode);
                    let param = new FormData();
                    param.append('token', _this.$global.token);
                    param.append('code', idCode);
                    _this.api.checkIdCardEnd(param).then(res => {
                        console.log(res);
                        _this.$message.success('验证成功');
                        _this.isCheck = 1;
                        _this.userDialogVisible = false;
                    }).catch(e => {
                        // _this.$message.error('验证失败');
                        _this.$router.push('vipCenter');
                    })
                } else {
                    _this.$message.error('请完整输入');
                }
            },
            handlCheckSubmin() {
                let _this = this;
                if (_this.param.passWord == _this.param.aginPassWord) {
                    _this.$refs.login.validate(valid => {
                        if (valid) {
                            let param = new FormData();
                            param.append('code', _this.code);
                            param.append('password', _this.param.aginPassWord);
                            param.append('token', _this.$global.token);
                            param.append('username', _this.$global.webData.phone);
                            _this.api.updatePassword(param).then(res => {
                                console.log(res);
                                _this.$message.success('修改成功，请重新登录');
                                // _this.$router.push({
                                //   path:'/'
                                // });
                                var storage = window.localStorage;
                                storage.clear();
                                _this.$router.push('login');

                                // location.reload();
                            })
                        }
                    })

                } else {
                    _this.$message.error('请输入密码');
                }
            }
        }
    }
</script>

<style scoped lang="less">
    @import '../../../../static/less/xm.less';

    #userDialog /deep/ .el-dialog__body {
        padding-left: 50px;
        padding-right: 50px;
    }

    #userDialog /deep/ .el-dialog {
        border-radius: 30px;
        border: solid 1px #aaaaaa;
    }

    #userDialog .dialog_num {
        width: @a;
        height: 60px;
        display: @flex;
        justify-content: center;
        align-items: center;

        .idCard {
            width: 115px;
            height: 60px;
            background-color: #ffffff;
            margin-left: 20px;
            .code-input /deep/ .el-input__inner{
                padding: 0!important;
                text-align: center!important;
            }
        }

        .idCard:first-child {
            margin-left: 0;
        }
    }

    #userDialog .dialog_text {
        width: @a;
        height: 60px;
        line-height: 60px;
        font-family: MicrosoftYaHei;
        font-size: 18px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 1px;
        color: #aaaaaa;
    }

    #userDialog .dialog_btn {
        width: @a;
        height: 80px;
        background-image: linear-gradient(270deg,
        #1e6eee 0%,
        #109ee7 50%,
        #01cee0 100%),
        linear-gradient(#000000,
        #000000);
        background-blend-mode: normal,
        normal;
        box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.5);
        color: #fff;
        line-height: 80px;
        text-align: center;
        font-size: 24px;
        cursor: pointer;
    }

    .change {
        width: @a;
        height: auto;
        margin-left: 4%;

        .title {
            width: 753px;
            height: 24px;
            font-family: MicrosoftYaHei-Bold;
            font-size: 24px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 1px;
            color: #333333;
            margin-bottom: 75px;
        }

        .submin {
            width: 520px;
            height: 80px;
            line-height: 80px;
            margin-top: 50px;
            text-align: center;
            letter-spacing: 1px;
            color: #ffffff;
            font-size: 24px;
            background-image: linear-gradient(270deg,
            #1e6eee 0%,
            #109ee7 50%,
            #01cee0 100%),
            linear-gradient(#000000,
            #000000);
            background-blend-mode: normal,
            normal;
            box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.5);
            margin-left: 200px;
            cursor: pointer;
        }

        .account {
            width: 753px;
            height: auto;
            display: @flex;
            align-items: center;
            margin-top: 30px;

            .acte {
                width: 230px;
                height: auto;
                font-family: MicrosoftYaHei-Bold;
                font-size: 24px;
                font-weight: bolder;
                font-stretch: normal;
                letter-spacing: 1px;
                color: #333333;
                text-align: end;
            }

            .key {
                width: 280px;
                height: 25px;
                font-family: MicrosoftYaHei-Bold;
                font-size: 24px;
                font-weight: bolder;
                font-stretch: normal;
                letter-spacing: 1px;
                color: #333333;
                margin-left: 34px;
            }

            .input {
                width: 520px;
                height: 60px;
                position: relative;

                /deep/ .el-input__inner {
                    width: 520px;
                    height: 60px;
                }

                .btn {
                    width: 150px;
                    height: 60px;
                    line-height: 60px;
                    text-align: center;
                    cursor: pointer;
                    background-color: #f5f5f5;
                    border: solid 1px #aaaaaa;
                    letter-spacing: 1px;
                    color: #333333;
                    position: absolute;
                    right: 0;
                    bottom: 0;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/page/login/changePassWord.vue